export const combineClasses = (classes: any) => {
  return classes.join(' ');
};
